import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";

const C = "DM Mono, monospace";
const S = "DM Sans, sans-serif";

// ─── Preview mini-UIs ────────────────────────────────────────────────────────

function PreviewDashboard() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
        {[
          { label: "Today's Revenue", value: "KSh 12,400", color: "#34d399", icon: "💰" },
          { label: "Active Agents",   value: "8 Online",   color: "#6366f1", icon: "🧑‍💼" },
          { label: "Transactions",    value: "47 Today",   color: "#38bdf8", icon: "📋" },
          { label: "Shops",           value: "3 Active",   color: "#f59e0b", icon: "🏪" },
        ].map(c => (
          <div key={c.label} style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 8, padding: "8px 10px" }}>
            <div style={{ fontSize: 13 }}>{c.icon}</div>
            <div style={{ fontFamily: S, fontWeight: 700, fontSize: 12, color: c.color, marginTop: 3 }}>{c.value}</div>
            <div style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.3)", marginTop: 2 }}>{c.label}</div>
          </div>
        ))}
      </div>
      <div style={{ background: "rgba(99,102,241,0.06)", border: "1px solid rgba(99,102,241,0.15)", borderRadius: 8, padding: "8px 10px" }}>
        <div style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.35)", marginBottom: 5 }}>SALES THIS WEEK</div>
        <div style={{ display: "flex", alignItems: "flex-end", gap: 4, height: 28 }}>
          {[40, 65, 45, 80, 55, 90, 70].map((h, i) => (
            <div key={i} style={{ flex: 1, background: `rgba(99,102,241,${0.3 + h / 200})`, borderRadius: "3px 3px 0 0", height: `${h}%` }} />
          ))}
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 3 }}>
          {["M","T","W","T","F","S","S"].map((d, i) => (
            <div key={i} style={{ fontFamily: C, fontSize: 8, color: "rgba(255,255,255,0.2)", flex: 1, textAlign: "center" }}>{d}</div>
          ))}
        </div>
      </div>
    </div>
  );
}

function PreviewAgents() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
      <div style={{ display: "flex", gap: 6 }}>
        <div style={{ flex: 1, background: "rgba(139,92,246,0.12)", border: "1px solid rgba(139,92,246,0.3)", borderRadius: 8, padding: "7px 10px", textAlign: "center" }}>
          <div style={{ fontFamily: S, fontSize: 11, fontWeight: 700, color: "#a78bfa" }}>+ Add Agent</div>
        </div>
        <div style={{ flex: 1, background: "rgba(56,189,248,0.1)", border: "1px solid rgba(56,189,248,0.25)", borderRadius: 8, padding: "7px 10px", textAlign: "center" }}>
          <div style={{ fontFamily: S, fontSize: 11, fontWeight: 700, color: "#38bdf8" }}>+ Create Shop</div>
        </div>
      </div>
      {[
        { code: "AGT-001", name: "John Mwangi",  role: "Sales Agent", color: "#34d399" },
        { code: "AGT-002", name: "Alice Wanjiru", role: "Shop Agent",  color: "#34d399" },
      ].map(a => (
        <div key={a.code} style={{ display: "flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 8, padding: "8px 10px" }}>
          <div style={{ width: 28, height: 28, borderRadius: "50%", background: "linear-gradient(135deg,#6366f1,#8b5cf6)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: S, fontWeight: 700, fontSize: 11, color: "#fff", flexShrink: 0 }}>
            {a.name[0]}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontFamily: S, fontWeight: 600, fontSize: 11, color: "#f9fafb" }}>{a.name}</div>
            <div style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.35)" }}>{a.code} · {a.role}</div>
          </div>
          <span style={{ fontFamily: C, fontSize: 9, color: a.color, background: `${a.color}18`, borderRadius: 5, padding: "2px 6px" }}>Active</span>
        </div>
      ))}
      <div style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.25)", textAlign: "center", paddingTop: 2 }}>
        Share your business code so agents can join instantly
      </div>
    </div>
  );
}

function PreviewCreateAgent() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {/* Subtitle */}
      <div style={{ fontFamily: C, fontSize: 8, color: "rgba(255,255,255,0.3)", marginBottom: 1 }}>
        Agent ID is auto-generated. They'll use it to log in.
      </div>
      {/* Fields */}
      {[
        { label: "FULL NAME *",          placeholder: "e.g. James Mwangi",   value: "" },
        { label: "ZONE / AREA",          placeholder: "e.g. Westlands",       value: "" },
        { label: "PHONE",                placeholder: "+254 7XX XXX XXX",     value: "" },
        { label: "DAILY TARGET (KSH)",   placeholder: "100000",               value: "" },
        { label: "PASSWORD *",           placeholder: "Min 6 characters",     value: "" },
      ].map(f => (
        <div key={f.label}>
          <div style={{ fontFamily: C, fontSize: 7, color: "rgba(255,255,255,0.35)", letterSpacing: "0.08em", marginBottom: 3 }}>{f.label}</div>
          <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 7, padding: "6px 10px" }}>
            <span style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.2)" }}>{f.placeholder}</span>
          </div>
        </div>
      ))}
      {/* Buttons */}
      <div style={{ display: "flex", gap: 8, marginTop: 2 }}>
        <div style={{ flex: 1, background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, padding: "8px 0", textAlign: "center", fontFamily: S, fontSize: 11, color: "rgba(255,255,255,0.4)" }}>Cancel</div>
        <div style={{ flex: 2, background: "linear-gradient(135deg,#6366f1,#06b6d4)", borderRadius: 8, padding: "8px 0", textAlign: "center", fontFamily: S, fontWeight: 700, fontSize: 11, color: "#fff" }}>Create Agent</div>
      </div>
    </div>
  );
}

function PreviewCreateShop() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {/* Subtitle */}
      <div style={{ fontFamily: C, fontSize: 8, color: "rgba(255,255,255,0.3)", marginBottom: 1 }}>
        Shop ID and code will be auto-generated
      </div>
      {/* Shop Name */}
      <div>
        <div style={{ fontFamily: C, fontSize: 7, color: "rgba(255,255,255,0.35)", letterSpacing: "0.08em", marginBottom: 3 }}>SHOP NAME *</div>
        <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 7, padding: "6px 10px" }}>
          <span style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.2)" }}>e.g. Westlands Branch</span>
        </div>
      </div>
      {/* Location */}
      <div>
        <div style={{ fontFamily: C, fontSize: 7, color: "rgba(255,255,255,0.35)", letterSpacing: "0.08em", marginBottom: 3 }}>LOCATION *</div>
        <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 7, padding: "6px 10px" }}>
          <span style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.2)" }}>e.g. Westlands, Nairobi</span>
        </div>
      </div>
      {/* Password — auto-generated with regenerate button */}
      <div>
        <div style={{ fontFamily: C, fontSize: 7, color: "rgba(255,255,255,0.35)", letterSpacing: "0.08em", marginBottom: 3 }}>PASSWORD</div>
        <div style={{ display: "flex", gap: 6 }}>
          <div style={{ flex: 1, background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.14)", borderRadius: 7, padding: "6px 10px" }}>
            <span style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.7)", letterSpacing: "0.05em" }}>PH9D-DA7Q</span>
          </div>
          <div style={{ background: "rgba(6,182,212,0.15)", border: "1px solid rgba(6,182,212,0.35)", borderRadius: 7, padding: "6px 10px", display: "flex", alignItems: "center", gap: 4 }}>
            <span style={{ fontFamily: C, fontSize: 9, color: "#06b6d4" }}>↺ New</span>
          </div>
        </div>
        <div style={{ fontFamily: C, fontSize: 8, color: "rgba(255,255,255,0.25)", marginTop: 3 }}>
          ⚠ Save this password — give it to the shop manager
        </div>
      </div>
      {/* Buttons */}
      <div style={{ display: "flex", gap: 8, marginTop: 2 }}>
        <div style={{ flex: 1, background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, padding: "8px 0", textAlign: "center", fontFamily: S, fontSize: 11, color: "rgba(255,255,255,0.4)" }}>Cancel</div>
        <div style={{ flex: 2, background: "linear-gradient(135deg,#6366f1,#06b6d4)", borderRadius: 8, padding: "8px 0", textAlign: "center", fontFamily: S, fontWeight: 700, fontSize: 11, color: "#fff" }}>🏪 Create Shop</div>
      </div>
    </div>
  );
}

function PreviewAssignAgent() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
      <div style={{ fontFamily: C, fontSize: 8, color: "rgba(255,255,255,0.3)", textTransform: "uppercase", letterSpacing: "0.07em" }}>Assign agents to a shop</div>
      {/* Shop selector */}
      <div style={{ background: "rgba(245,158,11,0.08)", border: "1px solid rgba(245,158,11,0.25)", borderRadius: 8, padding: "8px 10px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
          <span style={{ fontSize: 14 }}>🏪</span>
          <div>
            <div style={{ fontFamily: S, fontWeight: 700, fontSize: 11, color: "#f9fafb" }}>Westlands Branch</div>
            <div style={{ fontFamily: C, fontSize: 8, color: "rgba(255,255,255,0.3)" }}>Select agents to staff this shop</div>
          </div>
        </div>
        <span style={{ fontFamily: C, fontSize: 8, color: "#fbbf24" }}>▼</span>
      </div>
      {/* Agent assignment rows */}
      {[
        { code: "AGT-001", name: "John Mwangi",   assigned: true  },
        { code: "AGT-002", name: "Alice Wanjiru",  assigned: true  },
        { code: "AGT-003", name: "Brian Kamau",    assigned: false },
      ].map(a => (
        <div key={a.code} style={{ display: "flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,0.03)", border: `1px solid ${a.assigned ? "rgba(52,211,153,0.2)" : "rgba(255,255,255,0.06)"}`, borderRadius: 8, padding: "8px 10px" }}>
          <div style={{ width: 26, height: 26, borderRadius: "50%", background: "linear-gradient(135deg,#6366f1,#8b5cf6)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: S, fontWeight: 700, fontSize: 10, color: "#fff", flexShrink: 0 }}>
            {a.name[0]}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontFamily: S, fontWeight: 600, fontSize: 11, color: "#f9fafb" }}>{a.name}</div>
            <div style={{ fontFamily: C, fontSize: 8, color: "rgba(255,255,255,0.3)" }}>{a.code}</div>
          </div>
          {/* Toggle */}
          <div style={{ width: 34, height: 18, borderRadius: 99, background: a.assigned ? "rgba(52,211,153,0.25)" : "rgba(255,255,255,0.08)", border: `1px solid ${a.assigned ? "#34d399" : "rgba(255,255,255,0.12)"}`, position: "relative", flexShrink: 0 }}>
            <div style={{ position: "absolute", top: 2, left: a.assigned ? 16 : 2, width: 12, height: 12, borderRadius: "50%", background: a.assigned ? "#34d399" : "rgba(255,255,255,0.3)", transition: "left 0.2s" }} />
          </div>
        </div>
      ))}
      <div style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.25)", textAlign: "center", lineHeight: 1.5 }}>
        Assigned agents see this shop's sales in their Agent App
      </div>
    </div>
  );
}

function PreviewProducts() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
      <div style={{ background: "rgba(56,189,248,0.1)", border: "1px solid rgba(56,189,248,0.25)", borderRadius: 8, padding: "7px 12px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span style={{ fontFamily: S, fontSize: 11, fontWeight: 700, color: "#38bdf8" }}>+ Add Product</span>
        <span style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.3)" }}>Set name, price & stock</span>
      </div>
      {[
        { name: "Mineral Water 500ml", sku: "MW-001", price: "KSh 50",  stock: "2,400 units", bar: 75 },
        { name: "Soda 330ml",          sku: "SD-002", price: "KSh 80",  stock: "980 units",   bar: 45 },
        { name: "Energy Drink 250ml",  sku: "ED-003", price: "KSh 120", stock: "560 units",   bar: 28 },
      ].map(p => (
        <div key={p.sku} style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 8, padding: "8px 10px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 5 }}>
            <div>
              <div style={{ fontFamily: S, fontWeight: 600, fontSize: 11, color: "#f9fafb" }}>{p.name}</div>
              <div style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.3)" }}>{p.sku}</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontFamily: S, fontWeight: 700, fontSize: 11, color: "#38bdf8" }}>{p.price}</div>
              <div style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.35)" }}>{p.stock}</div>
            </div>
          </div>
          <div style={{ height: 3, background: "rgba(255,255,255,0.06)", borderRadius: 99 }}>
            <div style={{ height: 3, width: `${p.bar}%`, background: "#38bdf8", borderRadius: 99 }} />
          </div>
        </div>
      ))}
    </div>
  );
}

function PreviewTransactions() {
  const rows = [
    { agent: "AGT-001", name: "John M.",          amount: "KSh 250",   status: "ok",     time: "09:14 AM", isShop: false },
    { agent: "AGT-002", name: "Alice W.",          amount: "KSh 1,200", status: "ok",     time: "09:22 AM", isShop: false },
    { agent: "SHOP",    name: "Westlands Branch",  amount: "KSh 3,400", status: "ok",     time: "09:38 AM", isShop: true  },
    { agent: "AGT-001", name: "John M.",           amount: "KSh 80",    status: "review", time: "09:45 AM", isShop: false },
    { agent: "AGT-003", name: "Brian K.",          amount: "KSh 500",   status: "ok",     time: "10:02 AM", isShop: false },
  ];
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      <div style={{ display: "flex", justifyContent: "space-between", padding: "0 4px 4px" }}>
        {["Seller","Amount","Status","Time"].map(h => (
          <span key={h} style={{ fontFamily: C, fontSize: 8, color: "rgba(255,255,255,0.25)", textTransform: "uppercase", letterSpacing: "0.06em" }}>{h}</span>
        ))}
      </div>
      {rows.map((r, i) => (
        <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: r.isShop ? "rgba(245,158,11,0.05)" : "rgba(255,255,255,0.03)", border: `1px solid ${r.isShop ? "rgba(245,158,11,0.15)" : "rgba(255,255,255,0.05)"}`, borderRadius: 7, padding: "7px 8px" }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <div style={{ fontFamily: C, fontSize: 9, color: r.isShop ? "#f59e0b" : "#a78bfa" }}>{r.agent}</div>
              {r.isShop && <span style={{ fontFamily: C, fontSize: 7, color: "#f59e0b", background: "rgba(245,158,11,0.15)", borderRadius: 4, padding: "1px 4px" }}>SHOP</span>}
            </div>
            <div style={{ fontFamily: S, fontSize: 10, color: "rgba(255,255,255,0.5)" }}>{r.name}</div>
          </div>
          <div style={{ fontFamily: S, fontWeight: 700, fontSize: 11, color: r.status === "ok" ? "#34d399" : "#f9fafb" }}>{r.amount}</div>
          <span style={{ fontFamily: C, fontSize: 9, color: r.status === "ok" ? "#34d399" : "#fbbf24", background: r.status === "ok" ? "#34d39918" : "#fbbf2418", borderRadius: 5, padding: "2px 6px" }}>
            {r.status === "ok" ? "✓ ok" : "⚠ review"}
          </span>
          <div style={{ fontFamily: C, fontSize: 8, color: "rgba(255,255,255,0.25)" }}>{r.time}</div>
        </div>
      ))}
    </div>
  );
}

function PreviewReports() {
  // SVG area sparkline data
  const W = 280, H = 56;
  const data = [18, 32, 24, 48, 35, 62, 44, 70, 52, 81, 65, 90];
  const min = Math.min(...data);
  const max = Math.max(...data);
  const pts = data.map((v, i) => ({
    x: (i / (data.length - 1)) * W,
    y: H - ((v - min) / (max - min)) * H * 0.85 - H * 0.07,
  }));
  const linePath = pts.map((p, i) => `${i === 0 ? "M" : "L"}${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(" ");
  const areaPath = `${linePath} L${W},${H} L0,${H} Z`;

  const agents = [
    { rank: 1, name: "John Mwangi",   revenue: "KSh 14,200", bar: 100 },
    { rank: 2, name: "Alice Wanjiru", revenue: "KSh 9,800",  bar: 69  },
    { rank: 3, name: "Brian Kamau",   revenue: "KSh 6,100",  bar: 43  },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {/* SVG area chart */}
      <div style={{ background: "rgba(59,130,246,0.05)", border: "1px solid rgba(59,130,246,0.15)", borderRadius: 8, padding: "10px 12px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
          <span style={{ fontFamily: C, fontSize: 8, color: "rgba(255,255,255,0.3)", textTransform: "uppercase", letterSpacing: "0.07em" }}>Revenue · Last 12 Days</span>
          <span style={{ fontFamily: S, fontWeight: 700, fontSize: 10, color: "#34d399" }}>+34% ↑</span>
        </div>
        <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{ overflow: "visible", display: "block" }}>
          <defs>
            <linearGradient id="onb-area-grad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.35" />
              <stop offset="100%" stopColor="#3b82f6" stopOpacity="0" />
            </linearGradient>
          </defs>
          <path d={areaPath} fill="url(#onb-area-grad)" />
          <path d={linePath} fill="none" stroke="#3b82f6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          {/* Last point dot */}
          <circle cx={pts[pts.length - 1].x} cy={pts[pts.length - 1].y} r="3" fill="#3b82f6" />
        </svg>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}>
          {["1","","","4","","","7","","","10","","12"].map((d, i) => (
            <div key={i} style={{ fontFamily: C, fontSize: 7, color: "rgba(255,255,255,0.18)", textAlign: "center", flex: 1 }}>{d}</div>
          ))}
        </div>
      </div>

      {/* Leaderboard */}
      <div style={{ fontFamily: C, fontSize: 8, color: "rgba(255,255,255,0.3)", textTransform: "uppercase", letterSpacing: "0.07em" }}>Agent Leaderboard</div>
      {agents.map(a => (
        <div key={a.rank} style={{ display: "flex", alignItems: "center", gap: 7, background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 8, padding: "7px 9px" }}>
          <div style={{ width: 18, height: 18, borderRadius: "50%", flexShrink: 0, background: a.rank === 1 ? "linear-gradient(135deg,#fbbf24,#f59e0b)" : "rgba(255,255,255,0.07)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: S, fontWeight: 800, fontSize: 9, color: a.rank === 1 ? "#fff" : "rgba(255,255,255,0.35)" }}>
            {a.rank}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
              <span style={{ fontFamily: S, fontWeight: 600, fontSize: 10, color: "#f9fafb" }}>{a.name}</span>
              <span style={{ fontFamily: S, fontWeight: 700, fontSize: 10, color: "#60a5fa" }}>{a.revenue}</span>
            </div>
            <div style={{ height: 3, background: "rgba(255,255,255,0.06)", borderRadius: 99 }}>
              <div style={{ height: 3, width: `${a.bar}%`, background: "linear-gradient(90deg,#3b82f6,#2563eb)", borderRadius: 99 }} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function PreviewBilling() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 7 }}>
        {[
          { name: "Mkulima Mdogo", price: "KSh 399", color: "#06b6d4", features: ["5 Agents", "2 Shops", "Basic reports"] },
          { name: "Bossy",        price: "KSh 999", color: "#8b5cf6", features: ["Unlimited agents", "10 Shops", "Full analytics"] },
        ].map(p => (
          <div key={p.name} style={{ background: `${p.color}09`, border: `1px solid ${p.color}30`, borderRadius: 10, padding: "10px" }}>
            <div style={{ fontFamily: S, fontWeight: 800, fontSize: 12, color: p.color, marginBottom: 2 }}>{p.name}</div>
            <div style={{ fontFamily: S, fontWeight: 700, fontSize: 14, color: "#f9fafb", marginBottom: 6 }}>{p.price}</div>
            {p.features.map(f => (
              <div key={f} style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.4)", marginBottom: 2 }}>✓ {f}</div>
            ))}
          </div>
        ))}
      </div>
      <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: 8, padding: "8px 10px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <div style={{ fontFamily: S, fontSize: 10, fontWeight: 600, color: "#f9fafb" }}>M-Pesa Payment</div>
          <div style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.3)" }}>STK Push sent directly to your phone</div>
        </div>
        <div style={{ fontFamily: C, fontSize: 9, color: "#34d399", background: "#34d39918", borderRadius: 6, padding: "3px 8px" }}>Secure</div>
      </div>
    </div>
  );
}

function PreviewSettings() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
      {/* Profile section */}
      <div style={{ background: "rgba(99,102,241,0.07)", border: "1px solid rgba(99,102,241,0.2)", borderRadius: 8, padding: "10px 12px", display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ width: 36, height: 36, borderRadius: "50%", background: "linear-gradient(135deg,#6366f1,#8b5cf6)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: S, fontWeight: 800, fontSize: 14, color: "#fff", flexShrink: 0 }}>
          JO
        </div>
        <div>
          <div style={{ fontFamily: S, fontWeight: 700, fontSize: 12, color: "#f9fafb" }}>Joseph Oduor</div>
          <div style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.35)" }}>josephowang261@gmail.com</div>
        </div>
      </div>
      {/* Settings rows */}
      {[
        { label: "Business Name",   value: "My Business", icon: "🏢" },
        { label: "Business Code",   value: "BIZ-7A3F",    icon: "🔑", note: "Share with agents" },
        { label: "Daily Reports",   value: "Enabled",     icon: "📧", color: "#34d399" },
        { label: "Theme",           value: "Dark Mode",   icon: "🌙" },
      ].map(r => (
        <div key={r.label} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.05)", borderRadius: 7, padding: "7px 10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
            <span style={{ fontSize: 12 }}>{r.icon}</span>
            <div>
              <div style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.35)" }}>{r.label}</div>
              {r.note && <div style={{ fontFamily: C, fontSize: 8, color: "rgba(255,255,255,0.2)" }}>{r.note}</div>}
            </div>
          </div>
          <span style={{ fontFamily: C, fontSize: 9, color: (r as any).color ?? "rgba(255,255,255,0.5)" }}>{r.value}</span>
        </div>
      ))}
    </div>
  );
}

function PreviewComplete(_: { businessName: string }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <div style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.3)", textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 2 }}>
        Your 3-step quick start
      </div>
      {[
        { n: 1, icon: "🧑‍💼", title: "Add your first agent", desc: "Go to Agents & give them a business code to join" },
        { n: 2, icon: "📦", title: "Add your products",     desc: "Create products and allocate stock to each agent" },
        { n: 3, icon: "📲", title: "Share the Agent App",   desc: "Agents download it and start recording sales instantly" },
      ].map(s => (
        <div key={s.n} style={{ display: "flex", gap: 10, background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 8, padding: "9px 10px", alignItems: "flex-start" }}>
          <div style={{ width: 22, height: 22, borderRadius: "50%", background: "linear-gradient(135deg,#6366f1,#8b5cf6)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: S, fontWeight: 800, fontSize: 10, color: "#fff", flexShrink: 0 }}>
            {s.n}
          </div>
          <div>
            <div style={{ fontFamily: S, fontWeight: 700, fontSize: 11, color: "#f9fafb", marginBottom: 2 }}>
              {s.icon} {s.title}
            </div>
            <div style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.35)", lineHeight: 1.5 }}>{s.desc}</div>
          </div>
        </div>
      ))}
      {/* Support block */}
      <div style={{ background: "rgba(99,102,241,0.07)", border: "1px solid rgba(99,102,241,0.2)", borderRadius: 8, padding: "10px 12px" }}>
        <div style={{ fontFamily: C, fontSize: 9, color: "rgba(255,255,255,0.4)", lineHeight: 1.7 }}>
          <strong style={{ color: "rgba(255,255,255,0.65)", fontFamily: S, fontSize: 10 }}>Need help?</strong><br />
          WhatsApp: <span style={{ color: "#6366f1" }}>+254 783 069 010</span><br />
          Email: <span style={{ color: "#6366f1" }}>epicsoftwaredesigners@gmail.com</span><br />
          <span style={{ color: "rgba(255,255,255,0.25)" }}>We usually respond within a few hours.</span>
        </div>
      </div>
    </div>
  );
}

// ─── Step types ───────────────────────────────────────────────────────────────

type StepType = "welcome" | "nav" | "complete";

interface Step {
  type: StepType;
  tourKey: string | null;
  path: string | null;
  title: string;
  subtitle: string;
  description: string;
  color: string;
  Preview: (props: { businessName: string }) => React.ReactElement;
}

const STEPS: Step[] = [
  {
    type: "welcome",
    tourKey: null, path: null,
    title: "Welcome to QASHUP",
    subtitle: "Your business command centre",
    description: "In the next 60 seconds we'll walk you through every section so you can hit the ground running.",
    color: "#6366f1",
    Preview: () => (
      <div style={{ textAlign: "center", padding: "12px 0" }}>
        <div style={{ width: 64, height: 64, borderRadius: 18, background: "linear-gradient(135deg,#6366f1,#8b5cf6)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px", boxShadow: "0 8px 24px rgba(99,102,241,0.4)", fontFamily: S, fontWeight: 800, fontSize: 28, color: "#fff" }}>S</div>
        <div style={{ fontFamily: C, fontSize: 10, color: "rgba(255,255,255,0.35)", lineHeight: 1.9 }}>
          <span style={{ color: "#34d399" }}>✓</span> Real-time sales tracking<br />
          <span style={{ color: "#34d399" }}>✓</span> Agent & shop management<br />
          <span style={{ color: "#34d399" }}>✓</span> Automated daily email reports<br />
          <span style={{ color: "#34d399" }}>✓</span> M-Pesa integrated payments
        </div>
      </div>
    ),
  },
  {
    type: "nav",
    tourKey: "dashboard", path: "/dashboard",
    title: "Your Dashboard",
    subtitle: "Live business overview",
    description: "The moment you log in you see today's revenue, active agents, and transaction volume — everything at a glance.",
    color: "#6366f1",
    Preview: () => <PreviewDashboard />,
  },
  {
    type: "nav",
    tourKey: "agents", path: "/agents",
    title: "Agents & Shops",
    subtitle: "Build your sales team",
    description: "Add agents, create shops, and allocate stock. Each agent gets a unique code and logs in on the Agent App.",
    color: "#8b5cf6",
    Preview: () => <PreviewAgents />,
  },
  {
    type: "nav",
    tourKey: "agents", path: "/agents",
    title: "Creating an Agent",
    subtitle: "Your feet on the ground",
    description: "Click \"Add Agent\", fill in the agent's name and phone number — a login email and unique code are generated automatically. Share the business code so they can join on the Agent App.",
    color: "#a78bfa",
    Preview: () => <PreviewCreateAgent />,
  },
  {
    type: "nav",
    tourKey: "agents", path: "/agents",
    title: "Creating a Shop",
    subtitle: "A fixed point-of-sale location",
    description: "Click \"Create Shop\", enter the shop name and location. The shop gets its own QR scanner login that any assigned agent can use to record walk-in sales.",
    color: "#38bdf8",
    Preview: () => <PreviewCreateShop />,
  },
  {
    type: "nav",
    tourKey: "agents", path: "/agents",
    title: "Assigning Agents to a Shop",
    subtitle: "Staff your shops",
    description: "Open a shop, tap \"Manage Agents\", and toggle any agent on. Assigned agents can ring up sales at that shop — and their transactions appear under the shop in your reports.",
    color: "#fbbf24",
    Preview: () => <PreviewAssignAgent />,
  },
  {
    type: "nav",
    tourKey: "products", path: "/products",
    title: "Products",
    subtitle: "Your product catalogue",
    description: "Create products with a name, price, and total stock. Then allocate units to individual agents so they can start selling.",
    color: "#38bdf8",
    Preview: () => <PreviewProducts />,
  },
  {
    type: "nav",
    tourKey: "transactions", path: "/transactions",
    title: "Transactions",
    subtitle: "Every sale, in real time",
    description: "Every sale your agents record on the Agent App appears here immediately — amount, product, agent, and time.",
    color: "#10b981",
    Preview: () => <PreviewTransactions />,
  },
  {
    type: "nav",
    tourKey: "reports", path: "/reports",
    title: "Reports & Analytics",
    subtitle: "Know who's performing",
    description: "Revenue trends, agent leaderboards, stock alerts, and automated morning emails keep you fully informed every day.",
    color: "#3b82f6",
    Preview: () => <PreviewReports />,
  },
  {
    type: "nav",
    tourKey: "billing", path: "/billing",
    title: "Billing & Plans",
    subtitle: "Flexible M-Pesa pricing",
    description: "Pick a plan that fits your team size and pay monthly via M-Pesa. An STK push goes straight to your phone.",
    color: "#fbbf24",
    Preview: () => <PreviewBilling />,
  },
  {
    type: "nav",
    tourKey: "settings", path: "/settings",
    title: "Settings",
    subtitle: "Customise your experience",
    description: "Update your business name, manage your notification preferences, and share your business code with new agents.",
    color: "#6366f1",
    Preview: () => <PreviewSettings />,
  },
  {
    type: "complete",
    tourKey: null, path: null,
    title: "",       // overridden dynamically with business name
    subtitle: "You're all set",
    description: "",
    color: "#34d399",
    Preview: ({ businessName }) => <PreviewComplete businessName={businessName} />,
  },
];

const STEP_DURATION = 8000;
const SPOTLIGHT_PAD = 8;

// ─── Component ───────────────────────────────────────────────────────────────

interface Props {
  ownerId: string;
  businessName: string;
  onDone: () => void;
}

// Generate confetti particles once, stable across renders
const CONFETTI = Array.from({ length: 52 }, (_, i) => ({
  id: i,
  x: Math.random() * 100,           // vw %
  size: 6 + Math.random() * 8,
  delay: Math.random() * 1.2,        // s
  dur: 1.4 + Math.random() * 1.2,    // s
  rotate: Math.random() * 360,
  dx: (Math.random() - 0.5) * 60,   // horizontal drift vw
  color: ["#6366f1","#a78bfa","#34d399","#fbbf24","#fb7185","#38bdf8","#f59e0b","#e879f9"][i % 8],
  shape: i % 3 === 0 ? "circle" : "rect",
}));

export default function OnboardingTour({ ownerId, businessName, onDone }: Props) {
  const navigate = useNavigate();
  const [step,           setStep]           = useState(0);
  const [rect,           setRect]           = useState<DOMRect | null>(null);
  const [cursorPos,      setCursorPos]      = useState({ x: -80, y: -80 });
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [showConfetti,   setShowConfetti]   = useState(false);
  const [winW,           setWinW]           = useState(window.innerWidth);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const rafRef   = useRef<number | null>(null);
  const curRef   = useRef({ x: -80, y: -80 });

  useEffect(() => {
    const h = () => setWinW(window.innerWidth);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  const isMobile = winW < 768;
  const isTablet = winW >= 768 && winW < 1100;

  const current     = STEPS[step];
  const isWelcome   = current.type === "welcome";
  const isComplete  = current.type === "complete";
  const isCentered  = isWelcome || isComplete;

  const markDone = async () => {
    navigate("/dashboard");
    await supabase.from("profiles").update({ onboarding_shown: true }).eq("id", ownerId);
    onDone();
  };

  const goTo = (target: number) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (target >= STEPS.length) { markDone(); return; }
    setStep(target);
  };

  useEffect(() => {
    setTooltipVisible(false);
    setRect(null);
    if (current.path) navigate(current.path);

    const locate = () => {
      // On mobile the sidebar is hidden — skip element search, show card directly
      if (!current.tourKey || isMobile) { setTooltipVisible(true); return; }
      const el = document.querySelector(`[data-tour="${current.tourKey}"]`);
      if (el) {
        const r = el.getBoundingClientRect();
        setRect(r);
        animateCursor(r.left + r.width / 2, r.top + r.height / 2, () => setTooltipVisible(true));
      } else {
        setTooltipVisible(true);
      }
    };
    const t = setTimeout(locate, 380);
    return () => clearTimeout(t);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  useEffect(() => {
    if (!tooltipVisible) return;
    if (timerRef.current) clearTimeout(timerRef.current);
    if (isComplete) {
      // Fire confetti burst
      setShowConfetti(true);
      const t = setTimeout(() => setShowConfetti(false), 3200);
      return () => clearTimeout(t);
    }
    timerRef.current = setTimeout(() => goTo(step + 1), STEP_DURATION);
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tooltipVisible, step]);

  function animateCursor(toX: number, toY: number, cb: () => void) {
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    let { x: fx, y: fy } = curRef.current;
    if (fx < 0 || fx > window.innerWidth)  fx = window.innerWidth * 0.6;
    if (fy < 0 || fy > window.innerHeight) fy = window.innerHeight * 0.4;
    const dur = 750, start = performance.now();
    const tick = (now: number) => {
      const t = Math.min((now - start) / dur, 1);
      const e = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      const x = fx + (toX - fx) * e, y = fy + (toY - fy) * e;
      curRef.current = { x, y };
      setCursorPos({ x, y });
      if (t < 1) rafRef.current = requestAnimationFrame(tick); else cb();
    };
    rafRef.current = requestAnimationFrame(tick);
  }

  useEffect(() => () => {
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    if (timerRef.current) clearTimeout(timerRef.current);
  }, []);

  const sX = rect ? rect.left   - SPOTLIGHT_PAD : -9999;
  const sY = rect ? rect.top    - SPOTLIGHT_PAD : -9999;
  const sW = rect ? rect.width  + SPOTLIGHT_PAD * 2 : 0;
  const sH = rect ? rect.height + SPOTLIGHT_PAD * 2 : 0;

  const getCardPos = (): React.CSSProperties => {
    // Mobile: full-width bottom sheet
    if (isMobile) {
      return { bottom: 0, left: 0, right: 0, width: "100%", borderRadius: "22px 22px 0 0" };
    }
    // Tablet/desktop centered for welcome + complete
    if (isCentered || !rect) {
      return { top: "50%", left: "50%", transform: "translate(-50%,-50%)" };
    }
    const CARD_W = isTablet ? 300 : 340;
    const CARD_H = 620;
    const MARGIN = 16;
    let left = rect.right + MARGIN;
    if (left + CARD_W > window.innerWidth - MARGIN) left = Math.max(rect.right + 8, window.innerWidth / 2 - CARD_W / 2);
    let top = rect.top + rect.height / 2 - CARD_H / 2;
    top = Math.max(MARGIN, Math.min(top, window.innerHeight - CARD_H - MARGIN));
    return { top, left, width: CARD_W };
  };

  const cardPos = getCardPos();
  const { Preview } = current;

  const navSteps = STEPS.length - 2; // exclude welcome + complete from step counter
  const navIndex = step - 1;         // 1-based nav step index

  return (
    <>
      <style>{`
        @keyframes onb-pulse    { 0%,100%{transform:scale(1)} 50%{transform:scale(1.12)} }
        @keyframes onb-in       { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
        @keyframes onb-up       { from{opacity:0;transform:translateY(100%)} to{opacity:1;transform:translateY(0)} }
        @keyframes onb-pop      { from{opacity:0;transform:scale(0.92) translateY(12px)} to{opacity:1;transform:scale(1) translateY(0)} }
        @keyframes onb-pop-mob  { from{opacity:0;transform:translateY(100%) scale(0.97)} to{opacity:1;transform:translateY(0) scale(1)} }
        @keyframes onb-ring     { 0%{box-shadow:0 0 0 0 ${current.color}55} 70%{box-shadow:0 0 0 8px transparent} 100%{box-shadow:0 0 0 0 transparent} }
        @keyframes onb-bg       { from{opacity:0} to{opacity:1} }
        @keyframes onb-bar      { from{width:0%} to{width:100%} }
        @keyframes onb-confetti { 0%{transform:translateY(0) translateX(0) rotate(0deg);opacity:1} 100%{transform:translateY(-88vh) translateX(var(--cdx)) rotate(var(--cr));opacity:0} }
      `}</style>

      {/* ── Confetti burst ── */}
      {showConfetti && CONFETTI.map(p => (
        <div
          key={p.id}
          style={{
            position: "fixed",
            bottom: "-10px",
            left: `${p.x}vw`,
            width: p.shape === "circle" ? p.size : p.size * 0.6,
            height: p.size,
            borderRadius: p.shape === "circle" ? "50%" : 2,
            background: p.color,
            zIndex: 9500,
            pointerEvents: "none",
            opacity: 0,
            ["--cdx" as any]: `${p.dx}vw`,
            ["--cr"  as any]: `${p.rotate}deg`,
            animation: `onb-confetti ${p.dur}s ease-out ${p.delay}s forwards`,
          }}
        />
      ))}

      {/* ── Overlay ── */}
      <div style={{ position: "fixed", inset: 0, zIndex: 9000, pointerEvents: "none", animation: "onb-bg 0.3s ease" }}>
        {rect && !isCentered ? (
          <>
            <div style={{ position: "absolute", top: 0,       left: 0,       right: 0,    height: sY,         background: "rgba(5,7,14,0.84)" }} />
            <div style={{ position: "absolute", top: sY + sH, left: 0,       right: 0,    bottom: 0,          background: "rgba(5,7,14,0.84)" }} />
            <div style={{ position: "absolute", top: sY,      left: 0,       width: sX,   height: sH,         background: "rgba(5,7,14,0.84)" }} />
            <div style={{ position: "absolute", top: sY,      left: sX + sW, right: 0,    height: sH,         background: "rgba(5,7,14,0.84)" }} />
          </>
        ) : (
          <div style={{ position: "absolute", inset: 0, background: "rgba(5,7,14,0.84)" }} />
        )}
        {rect && !isCentered && !isMobile && (
          <div style={{
            position: "absolute",
            top: sY - 2, left: sX - 2, width: sW + 4, height: sH + 4,
            borderRadius: 14,
            border: `2px solid ${current.color}`,
            boxShadow: `0 0 0 3px ${current.color}20, 0 0 18px ${current.color}45`,
            animation: "onb-ring 1.8s ease infinite",
          }} />
        )}
      </div>

      {/* ── Cursor (desktop only) ── */}
      {!isCentered && !isMobile && (
        <div style={{
          position: "fixed", left: cursorPos.x - 5, top: cursorPos.y - 3,
          zIndex: 9100, pointerEvents: "none",
          animation: tooltipVisible ? "onb-pulse 1.4s ease infinite" : "none",
          filter: "drop-shadow(0 2px 5px rgba(0,0,0,0.6))",
        }}>
          <svg width="20" height="24" viewBox="0 0 20 24" fill="none">
            <path d="M0 0L0 18L5 13.5L8 20L10.5 19L7.5 12.5L13 12.5L0 0Z" fill="white" stroke="#0d1117" strokeWidth="1.5" strokeLinejoin="round" />
          </svg>
        </div>
      )}

      {/* ── Card ── */}
      {tooltipVisible && (
        <div style={{
          position: "fixed",
          ...cardPos,
          zIndex: 9200,
          background: "linear-gradient(160deg,#13182a 0%,#0c1020 100%)",
          border: `1px solid ${current.color}30`,
          borderRadius: isMobile ? "22px 22px 0 0" : 20,
          overflow: "hidden",
          boxShadow: isMobile
            ? `0 -8px 40px rgba(0,0,0,0.7), 0 0 0 1px ${current.color}15`
            : `0 24px 64px rgba(0,0,0,0.75), 0 0 0 1px ${current.color}15, 0 0 80px ${current.color}08`,
          animation: isMobile
            ? (isComplete ? "onb-pop-mob 0.4s cubic-bezier(0.16,1,0.3,1)" : "onb-up 0.32s cubic-bezier(0.16,1,0.3,1)")
            : (isComplete ? "onb-pop 0.4s cubic-bezier(0.16,1,0.3,1)" : "onb-in 0.3s cubic-bezier(0.16,1,0.3,1)"),
          pointerEvents: "auto",
          width: isMobile ? "100%" : (isCentered ? 380 : undefined),
          maxHeight: isMobile ? "80vh" : "90vh",
          overflowY: "auto",
        }}>

          {/* Mobile drag handle */}
          {isMobile && (
            <div style={{ display: "flex", justifyContent: "center", paddingTop: 10, paddingBottom: 2 }}>
              <div style={{ width: 36, height: 4, borderRadius: 99, background: "rgba(255,255,255,0.15)" }} />
            </div>
          )}

          {/* Accent stripe */}
          {!isMobile && <div style={{ height: 3, background: `linear-gradient(90deg,${current.color},${current.color}55,transparent)`, flexShrink: 0 }} />}

          {/* Timer bar */}
          {!isComplete && (
            <div style={{ height: 2, background: "rgba(255,255,255,0.04)", overflow: "hidden", flexShrink: 0 }}>
              <div key={step} style={{ height: "100%", background: `${current.color}55`, animation: `onb-bar ${STEP_DURATION}ms linear forwards` }} />
            </div>
          )}

          <div style={{ padding: isMobile ? "14px 18px 28px" : "20px 22px 22px" }}>

            {/* ── Complete screen header ── */}
            {isComplete ? (
              <div style={{ textAlign: "center", marginBottom: isMobile ? 14 : 20 }}>
                <div style={{ fontSize: isMobile ? 32 : 40, marginBottom: 8, lineHeight: 1 }}>🎉</div>
                <div style={{ fontFamily: C, fontSize: 9, color: "#34d399", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 5 }}>
                  You're all set
                </div>
                <div style={{ fontFamily: S, fontWeight: 800, fontSize: isMobile ? 17 : 20, color: "#f9fafb", lineHeight: 1.25, marginBottom: 6 }}>
                  Welcome,{" "}
                  <span style={{ background: "linear-gradient(135deg,#6366f1,#a78bfa)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>
                    {businessName}
                  </span>
                </div>
                <div style={{ fontFamily: C, fontSize: isMobile ? 10 : 11, color: "rgba(255,255,255,0.45)", lineHeight: 1.7 }}>
                  Your dashboard is ready. We're genuinely excited to be part of your journey. Start small — one agent, one product — and grow from there.
                </div>
              </div>
            ) : (
              /* ── Normal step header ── */
              <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: isMobile ? 10 : 14 }}>
                <div style={{ flex: 1, minWidth: 0, paddingRight: 8 }}>
                  <div style={{ fontFamily: C, fontSize: 9, color: current.color, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 3 }}>
                    {isWelcome ? "Getting Started" : `Step ${navIndex} of ${navSteps}`}
                  </div>
                  <div style={{ fontFamily: S, fontWeight: 800, fontSize: isMobile ? 15 : 17, color: "#f9fafb", lineHeight: 1.2 }}>{current.title}</div>
                  <div style={{ fontFamily: C, fontSize: isMobile ? 9 : 10, color: current.color, marginTop: 2, opacity: 0.8 }}>{current.subtitle}</div>
                </div>
                <button
                  onClick={markDone}
                  style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.09)", borderRadius: 8, width: 28, height: 28, cursor: "pointer", color: "rgba(255,255,255,0.38)", fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}
                  title="Skip tour"
                >×</button>
              </div>
            )}

            {/* Description (non-complete) */}
            {!isComplete && (
              <div style={{ fontFamily: C, fontSize: isMobile ? 10 : 11, color: "rgba(255,255,255,0.48)", lineHeight: 1.7, marginBottom: isMobile ? 10 : 14 }}>
                {current.description}
              </div>
            )}

            {/* Preview panel */}
            <div style={{ background: "rgba(0,0,0,0.28)", border: `1px solid ${current.color}15`, borderRadius: 12, padding: isMobile ? "10px 11px 9px" : "13px 13px 11px", marginBottom: isMobile ? 12 : 16 }}>
              {!isComplete && (
                <div style={{ fontFamily: C, fontSize: 8, color: `${current.color}99`, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: isMobile ? 7 : 9 }}>
                  Preview
                </div>
              )}
              <Preview businessName={businessName} />
            </div>

            {/* Step dots */}
            <div style={{ display: "flex", justifyContent: "center", gap: isMobile ? 4 : 5, marginBottom: isMobile ? 10 : 14 }}>
              {STEPS.map((_, i) => (
                <div
                  key={i}
                  onClick={() => i !== step && goTo(i)}
                  style={{
                    width: i === step ? 16 : 5, height: 5, borderRadius: 99,
                    background: i === step ? current.color : i < step ? `${current.color}50` : "rgba(255,255,255,0.1)",
                    transition: "width 0.25s ease, background 0.25s ease",
                    cursor: i !== step ? "pointer" : "default",
                  }}
                />
              ))}
            </div>

            {/* Buttons */}
            <div style={{ display: "flex", gap: 8 }}>
              {step > 0 && !isComplete && (
                <button
                  onClick={() => goTo(step - 1)}
                  style={{ flex: 1, background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.09)", borderRadius: 11, padding: isMobile ? "12px 0" : "11px 0", color: "rgba(255,255,255,0.5)", fontFamily: S, fontWeight: 600, fontSize: isMobile ? 14 : 13, cursor: "pointer" }}>
                  ← Back
                </button>
              )}
              <button
                onClick={() => isComplete ? markDone() : goTo(step + 1)}
                style={{
                  flex: (step > 0 && !isComplete) ? 2 : 1,
                  background: isComplete
                    ? "linear-gradient(135deg,#34d399,#10b981)"
                    : `linear-gradient(135deg,${current.color},${current.color}bb)`,
                  border: "none", borderRadius: 11, padding: isMobile ? "14px 0" : "12px 0",
                  color: "#fff", fontFamily: S, fontWeight: 700, fontSize: isMobile ? 15 : 14,
                  cursor: "pointer",
                  boxShadow: isComplete ? "0 4px 20px rgba(52,211,153,0.4)" : `0 4px 16px ${current.color}38`,
                }}>
                {isComplete ? "Open My Dashboard →" : step === 0 ? "Start Tour →" : step < STEPS.length - 2 ? "Next →" : "Finish Tour"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
